import React from "react";
import { FormControl, FormField, FormItem, FormMessage } from "@/components/ui/form";
import { LookupSelect } from "@/components/lookupSelect";
import type { JSONFieldSchema, RowState } from "@/components/advanceSearch/types";
import { Input } from "@/components/input";

interface Props {
  row: RowState;
  control: any;
  onClear: (which: "value" | "value2") => void;
  fieldSchema?: JSONFieldSchema;
  dropdownPortalId?: string;
}

export const ConditionJSONInput: React.FC<Props> = ({
  row,
  control,
  onClear,
  fieldSchema,
  dropdownPortalId
}) => (
  <FormField
    control={control}
    name={`value_${row.id}` as const}
    rules={{ required: "This field is required." }}
    render={({ field, fieldState }) => {
      const value = Array.isArray(field.value) ? field.value : [];

      const handleChange = (tags: string[]) => {
        field.onChange(tags);
      };

      const handleClear = () => {
        field.onChange([]);
        onClear("value");
      };

      return (
        <FormItem className="relative w-full overflow-x-hidden">
          <FormControl>
            {fieldSchema?.fetchSuggestions ?
              <LookupSelect
                value={value}
                onChange={handleChange}
                onClear={handleClear}
                error={Boolean(fieldState.error)}
                placeholder={fieldSchema?.placeholder}
                maxTags={row.operator === "containsAny" ? fieldSchema?.maxTags : 1}
                fetchSuggestions={fieldSchema?.fetchSuggestions}
                suggestionDebounce={fieldSchema?.suggestionDebounce}
                noOptionsMessage={fieldSchema?.noOptionsMessage}
                loadingMessage={fieldSchema?.loadingMessage}
                dropdownPortalId={dropdownPortalId}
              />
            : <Input
                {...field}
                value={field.value ?? ""}
                autoComplete="off"
                inputMode="text"
                className="w-full h-9 rounded-md bg-white pr-8 text-sm text-gray-700 shadow-none focus-visible:ring-0 focus-visible:ring-offset-0"
              />
            }
          </FormControl>
          <FormMessage className={"absolute left-0 top-full mt-1 text-xs text-red-600"} />
        </FormItem>
      );
    }}
  />
);
